module.exports = __webpack_public_path__ + "static/what-we-do-consulting-748b21f96cead70e1659ec75473a80f0.jpg";